import { render, staticRenderFns } from "./PhGear.vue?vue&type=template&id=f425b4c6"
import script from "./PhGear.vue?vue&type=script&lang=js"
export * from "./PhGear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports